<div style="display: flex; flex-flow: column nowrap; gap: 40px">

	<div class="aTitle">

		<mat-icon>
			create_new_folder
		</mat-icon>

		<span>
			Ordnererstellung
		</span>

	</div>

	<mat-form-field appearance="outline" subscriptSizing="dynamic">

		<mat-label>Ordnername</mat-label>

		<input
			matInput
			type="text"
			[formControl]="folderNameCtrl"
		>

	</mat-form-field>

	<div style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px;">

		<button
			mat-raised-button
			(click)="dialogRef.close(false)"
		>
			Abbrechen
		</button>

		<button
			mat-flat-button
			[disabled]="!folderNameCtrl.value"
			(click)="dialogRef.close(folderNameCtrl.value)"
		>
			OK
		</button>

	</div>

</div>